import { productReportsReducer } from "../reducer/ProductReportsReducer";

export const reducer = productReportsReducer;
